import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AppVersionService {
    constructor(private readonly http: HttpClient) {}

    getBuildVersion() {
        return this.http
            .get(`${location.origin}/app/resource/version.jsp`, { responseType: 'text' })
            .pipe(map((version) => this.extractVersionNumber(version)));
    }

    private extractVersionNumber(res: string) {
        let str: string | null = Object.values(res).join('');
        let index = str.indexOf('<body>');
        str = str.slice(index + 6);
        index = str.indexOf('</body>');
        str = str.slice(0, index);
        const div = document.createElement('div');
        div.innerHTML = str;
        str = div.textContent;
        // @ts-ignore
        return str.replaceAll('\n', '');
    }
}
